export default "__VITE_ASSET__CFrXkIn8__"